// The Global room (Brief 4 / P8) — the general, cross-project chat pinned to the
// top of the Dashboard sidebar (like a Discord #general). It IS one chat thread,
// rendered with the shared operator conversation; no agent activity / steer (it
// is not an agent session). Reuses the session channel hook on live transport.

import { useChannel } from "@waytide/ui";
import { Conversation } from "../Conversation";
import { useGlobalRoom } from "./useGlobalRoom";

export function GlobalRoom() {
  const { threadId, loading, error } = useGlobalRoom();
  const { messages, send, pending, retry } = useChannel(threadId);

  return (
    <div className="wt-dash-pane">
      <header className="wt-dash-pane__head">
        <h1 className="wt-dash-pane__title"># Global</h1>
        <p className="wt-dash-pane__sub">General chat across every project.</p>
      </header>
      {error ? (
        <p className="wt-dash-empty">Couldn't open the Global room: {error}</p>
      ) : loading ? (
        <p className="wt-dash-empty">Opening the Global room…</p>
      ) : (
        <Conversation
          messages={messages}
          onSend={(b) => void send(b)}
          placeholder="Message the Global room…"
          emptyHint="No messages yet. This is the general room — say hello."
          draftScope={threadId}
          pending={pending}
          onRetry={retry}
        />
      )}
    </div>
  );
}
